import {validatePhone} from "../utils/validatePhone";
import {validateEmail} from "../utils/validateEmail";
import {leadFormApi} from "../api/leadForm";
import {
    ERROR_FORM_STATUS_TEXT,
    ERROR_FORM_STATUS_TITLE,
    SUCCESS_FORM_STATUS_TEXT,
    SUCCESS_FORM_STATUS_TITLE
} from "../constants";

export default (pageId) => ({
    pageId: pageId,
    name: '',
    phone: '',
    email: '',
    languagesConsts: {
        english: 'english',
        german: 'german',
        italian: 'italian',
        none: 'none'
    },
    deadlinesConsts: {
        sixMonths: 'sixMonths',
        oneYear: 'oneYear',
        twoYears: 'twoYears',
        later: 'later'
    },
    languages: [],
    customLanguage: '',
    savedCustomLanguage: '',
    planningDeadline: null,
    fieldsValidationState: {
        name: false,
        phone: false,
        email: false,
        customLanguage: false,
    },
    loading: false,
    hasLanguage(language) {
        return this.languages.includes(language);
    },
    onUpdateLanguageCheckbox(checkboxValue, language) {
        if (checkboxValue) {
            this.addLanguage(language);
        } else {
            this.removeLanguage(language);
        }
    },
    onUpdatePlanningDeadline(radioValue, deadlineValue) {
        if (radioValue) {
            this.planningDeadline = deadlineValue;
        }
    },
    addLanguage(language) {
        this.languages.push(language);
    },
    removeLanguage(language) {
        this.languages = this.languages.filter(l => l !== language);
    },
    resetForm() {
        this.name = '';
        this.phone = '';
        this.email = '';
        this.languages = [];
        this.customLanguage = '';
        this.planningDeadline = this.deadlinesConsts.sixMonths;
        this.fieldsValidationState = {
            name: false,
            phone: false,
            email: false,
            customLanguage: false,
        }
    },
    async onSend() {
        let validationCorrect = true;
        if (this.name.length === 0) {
            validationCorrect = false;
            this.fieldsValidationState.name = true;
        }
        if (this.phone.length === 0 || !validatePhone(this.phone)) {
            validationCorrect = false;
            this.fieldsValidationState.phone = true;
        }
        if (this.email.length === 0 || !validateEmail(this.email)) {
            validationCorrect = false;
            this.fieldsValidationState.email = true;
        }
        if (!this.validateLanguages()) {
            validationCorrect = false;
        }
        if (!validationCorrect) {
            return false;
        }
        this.loading = true;
        try {
            await leadFormApi.create({
                source: this.pageId,
                name: this.name,
                phone: this.phone,
                email: this.email,
                languages: this.languages,
                customLanguage: this.customLanguage,
                planningDeadline: this.planningDeadline,
            });
            this.$store.formStatusPopup.open('success', SUCCESS_FORM_STATUS_TITLE, SUCCESS_FORM_STATUS_TEXT);
            this.resetForm();
        } catch (error) {
            this.$store.formStatusPopup.open('error', ERROR_FORM_STATUS_TITLE, ERROR_FORM_STATUS_TEXT);
        }
        this.loading = false;
    },
    validateLanguages() {
        if (this.languages.length === 0 && this.customLanguage.length === 0) {
            this.fieldsValidationState.customLanguage = true;
            return false;
        } else {
            this.fieldsValidationState.customLanguage = false;
        }
        return true;
    },
    init() {
        this.resetForm();
        this.$watch('languages', (value) => {
            this.validateLanguages();
            if (value.length !== 0) {
                if (this.savedCustomLanguage.length === 0) {
                    this.savedCustomLanguage = this.customLanguage;
                }
                if (this.hasLanguage(this.languagesConsts.none) && value.length !== 1) {
                    this.languages = [this.languagesConsts.none];
                }
                this.customLanguage = '';
            } else {
                this.customLanguage = this.savedCustomLanguage;
            }
        });
        this.$watch('customLanguage', (value) => {
            this.validateLanguages();
        });
        this.$watch('name', () => {
            this.fieldsValidationState.name = false;
        });
        this.$watch('phone', () => {
            this.fieldsValidationState.phone = false;
        });
        this.$watch('email', () => {
            this.fieldsValidationState.email = false;
        });
    }
});